
import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';


import { PlotlyModule } from 'angular-plotly.js';
import { IdeaGenerationServiceService } from '../../services/idea-generation-service.service';
import { Store } from '@ngrx/store';

import { ITreemapData, ITreemapQuery } from '../../../../core/models/idea-generation.model';
import { IdeaGenStateService } from '../../idea-gen-state.service';
import { submitSearch } from '../../../../state/action';


@Component({
  selector: 'app-theme-trends',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, PlotlyModule],
  templateUrl: './theme-trends.component.html',
  styleUrl: './theme-trends.component.css',
})
export class ThemeTrendsComponent implements OnInit {
  constructor(private store: Store, private ideaGenService: IdeaGenerationServiceService, private stateService: IdeaGenStateService) {
    this.stateService.treemapQuery$.subscribe((treemapQuery) => {
      this.showSpinner = true;
      this.showPlot = false;
      this.showTheme = false;
      this.selectedTheme = '';
      setTimeout(() => {
        this.getTreemapData(treemapQuery);
 
      }, 0);
    })
  }


  showSpinner: boolean = false;
  showPlot: boolean = false;
  ngOnInit(): void {
  }
  treemaptype: string = 'normal';
  onSearchTypeToggle(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    this.treemaptype = inputElement.checked ? 'delta' : 'normal';
    if(this.treemaptype=='delta'){
      this.plotRelativeGrowthDeltaTreemap();
    }else{
      this.plotRelativeGrowthTreemap();
    }
    
  }

showDataMissing: boolean = false;
  treemap_data: ITreemapData[] = [];
  getTreemapData(query: ITreemapQuery) {
    this.showDataMissing = false;
    this.showSpinner = true;
    this.showPlot = false;
    this.showTheme = false;
    this.selectedTheme = '';
    this.ideaGenService.getTreemapData(query).subscribe({
      next: (res) => {
        if(res.status === 204){
          this.showDataMissing = true;
          this.showSpinner = false;
          this.showPlot = false;
          this.showTheme = false;
          return;
        }
        const payload = res.body!.payload;
        this.treemapData = payload;
        this.plotRelativeGrowthDeltaTreemap();
        this.showSpinner = false;
        this.showPlot = true;
      },
      error: (err) => {
        alert("Failed to load the data for treemap!");
        this.showSpinner = false;
        this.showDataMissing = false;
        this.showPlot = false;
      },
    });
  }
  treemapDataValues: any;
  layout: any;
  config: any;
  treemapData:ITreemapData|undefined=undefined;
 percentile(arr: number[], p: number) {
    const a = [...arr].sort((x,y)=>x-y);
    const i = (a.length - 1) * p;
    const lo = Math.floor(i), hi = Math.ceil(i);
    const t = i - lo;
    return lo === hi ? a[lo] : a[lo] * (1 - t) + a[hi] * t;
  }
  plotRelativeGrowthDeltaTreemap() {
    if (!this.treemapData) {
      return;
    }
    this.showPlot = false;
    

    // const minVal = Math.min(...this.treemapData.relative_growth);
    // const maxVal = Math.max(...this.treemapData.relative_growth);
    const minVal = this.treemapData.cmin_relative_growth_delta;
    const maxVal =this.treemapData.cmax_relative_growth_delta;
    const deltas = this.treemapData.relative_growth_delta;
    const p5  = this.percentile(deltas, 0.05);
    const p95 = this.percentile(deltas, 0.95);
    const trace = {
      type: 'treemap',
      branchvalues:'total',
      ids: this.treemapData.ids,        
      labels: this.treemapData.labels,   
      parents: this.treemapData.parents, 
      values: this.treemapData.values,   
      marker: {
        colors: this.treemapData.relative_growth_delta, 
        colorscale: [
          [0, '#d60000'],  
          [0-p5 / (p95 - p5), 'white'],  
          [1, 'green']      
        ],
        cmin: p5,           // robust lower bound
        cmax: p95,          // robust upper bound
        cmid: 0,            // keep 0 at the white midpoint
        colorbar: {
          title: 'Relative Growth (%)',
          tickformat: '.0f'
        }
      },
      text: this.treemapData.labels.map((label, index) => {
        const relativeGrowth = this.treemapData!.relative_growth_delta[index];
        const absoluteGrowth = this.treemapData!.values![index];
        const formattedGrowth = relativeGrowth != null && !isNaN(relativeGrowth) ? relativeGrowth.toFixed(2) : 'N/A';
        return `Relative Growth: ${formattedGrowth}%<br>Absolute Growth: ${absoluteGrowth} Inv`;
      }),
      // textinfo: 'label+value+percent entry',  
      // maxdepth:2
    };
    
    const layout = {
      // title: 'Innovation Treemap',
      margin: { t: 50, l: 25, r: 25, b: 25 },
      height: 800,
      // maxdepth:1
    };

    this.treemapDataValues = {
      data: [trace],
      layout: layout
    };
    this.showSpinner = false;
    this.showPlot = true;
  }




  plotRelativeGrowthTreemap() {
    if (!this.treemapData) {
      return;
    }
    this.showPlot = false;

    // const minVal = Math.min(...this.treemapData.relative_growth);
    // const maxVal = Math.max(...this.treemapData.relative_growth);
   // const minVal = this.treemapData.cmin_relative_growth;
   // const maxVal =this.treemapData.cmax_relative_growth;
    const maxVal =100;
    const minVal = -100;


    const trace = {
      type: 'treemap',
      branchvalues: 'total',
      ids: this.treemapData.ids,
      labels: this.treemapData.labels,
      parents: this.treemapData.parents,
      values: this.treemapData.values,
      marker: {
        colors: this.treemapData.relative_growth,
        colorscale: [
          [0, '#d60000'],      
          [(0 - minVal) / (maxVal - minVal), 'white'], 
          [(25 - minVal) / (maxVal - minVal), 'green'], 
          [1, 'green'],        
        ],
        cmin: minVal,            
        cmax: maxVal,  
        colorbar: {
          title: 'Relative Growth (%)',
          tickvals: [minVal, (0), maxVal],
          ticktext: [`${minVal}%`, `${(0).toFixed(0)}%`, '>100%'],
        },
      },
      text: this.treemapData.labels.map((label, index) => {
        const relativeGrowth = this.treemapData!.relative_growth[index];
        const absoluteGrowth = this.treemapData!.values![index];
        const formattedGrowth = relativeGrowth != null && !isNaN(relativeGrowth) ? relativeGrowth.toFixed(2) : 'N/A';
        return `Relative Growth: ${formattedGrowth}%<br>Absolute Growth: ${absoluteGrowth} Inv`;
      }),
      // textinfo: 'label+value+percent entry',  
      // maxdepth:2
    };
    const layout = {
      title: 'Innovation Treemap',
      margin: { t: 50, l: 25, r: 25, b: 25 },
      height: 800,
      // maxdepth:1
    };

    this.treemapDataValues = {
      data: [trace],
      layout: layout
    };
    this.showSpinner = false;
    this.showPlot = true;
  } 
  selectedThemeQuery: string = ' ';
  selectedTheme: string = '';
  showTheme: Boolean = false;
  handleClick(event: any) {
    const clickedData = event.points[0];
    if (clickedData.parent && clickedData.parent !== "Innovation Treemap") {
      this.selectedTheme = clickedData.label;
      this.showTheme = true;
      this.selectedThemeQuery = `tf="${this.selectedTheme}"`;
    } else {
      this.selectedTheme = '';
      this.showTheme = false;
    }
  }

  submitTheme() {
    const searchParams = { 'themes': [{ 'api_query': this.selectedThemeQuery, 'name': this.selectedTheme }] };
    this.store.dispatch(submitSearch({ searchParams, searchType: 'theme' }));
  }
}
